import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

import DefaultLayout from "@/layouts/DefaultLayout.vue";

import DasboardView from "@/views/DashboardView.vue";
import ManageUsers from "@/views/users/ManageUsers.vue";
import LoginView from "@/views/auth/LoginView.vue";
import MapView from "@/views/managing/data/MapView.vue";
import DocumentationView from "@/views/support/DocumentationView.vue";

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { requiresGuest: true },
  },
  {
    path: "/",
    redirect: "/dashboard",
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/dashboard",
        component: DasboardView,
        meta: { title: "Pagrindinis" },
      },
      {
        path: "/data/view",
        component: MapView,
        meta: { title: "Duomenų peržiūra" },
      },
      {
        path: "users",
        component: ManageUsers,
        meta: { title: "Vartotojai" },
      },
      {
        path: "support/documentation",
        component: DocumentationView,
        meta: { title: "Dokumentacija" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const isAuthenticated = authStore.isAuthenticated;

  // If route requires auth and user is not authenticated
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: "login" });
      return;
    }
  }

  // If route requires guest and user is authenticated (like login page)
  if (to.matched.some((record) => record.meta.requiresGuest)) {
    if (isAuthenticated) {
      next({ path: "/dashboard" });
      return;
    }
  }

  next();
});

export default router;
